// Helper function to convert trigger time to minutes
export const convertToMinutes = (value, unit) => {
	switch (unit) {
		case 'MINUTES':
			return value;
		case 'HOURS':
			return value * 60;
		case 'DAYS':
			return value * 24 * 60;
		default:
			return value;
	}
};

// Helper function to convert minutes back to value and unit
export const convertFromMinutes = (minutes) => {
	if (minutes < 60) {
		return { value: minutes, unit: 'MINUTES' };
	} else if (minutes < 1440) {
		return { value: Math.floor(minutes / 60), unit: 'HOURS' };
	} else {
		return { value: Math.floor(minutes / 1440), unit: 'DAYS' };
	}
};

// Predefined trigger options based on campaign type and sequence index
export const getTriggerOptions = (campaignSlug, sequenceIndex) => {
	// Default 2nd and 3rd sequence options for most campaigns
	const defaultSecondThirdOptions = [
		{ value: '12_HOURS', label: '12 Hours (After first campaign)', minutes: 12 * 60 },
		{ value: '1_DAY', label: '1 Day (After first campaign)', minutes: 24 * 60 },
		{ value: 'CUSTOM', label: 'Custom (After first campaign)', minutes: null }
	];

	const defaultThirdOptions = [
		{ value: '12_HOURS', label: '12 Hours (After second campaign)', minutes: 12 * 60 },
		{ value: '1_DAY', label: '1 Day (After second campaign)', minutes: 24 * 60 },
		{ value: 'CUSTOM', label: 'Custom (After second campaign)', minutes: null }
	];

	switch (campaignSlug) {
		case 'WELCOME_USER':
			if (sequenceIndex === 0) {
				return [
					{ value: '2_MINUTES', label: '2 Minutes (After app installed)', minutes: 2 },
					{ value: '15_MINUTES', label: '15 Minutes (After app installed)', minutes: 15 },
					{ value: 'CUSTOM', label: 'Custom (After app installed)', minutes: null }
				];
			} else if (sequenceIndex === 1) {
				return defaultSecondThirdOptions;
			} else {
				return defaultThirdOptions;
			}

		case 'ABANDONED_CART':
			if (sequenceIndex === 0) {
				return [
					{ value: '30_MINUTES', label: '30 Minutes (After abandoned cart)', minutes: 30 },
					{ value: '2_HOURS', label: '2 Hours (After abandoned cart)', minutes: 2 * 60 },
					{ value: 'CUSTOM', label: 'Custom (After abandoned cart)', minutes: null }
				];
			} else if (sequenceIndex === 1) {
				return defaultSecondThirdOptions;
			} else {
				return defaultThirdOptions;
			}

		case 'REMOVED_FROM_CART':
			if (sequenceIndex === 0) {
				return [
					{ value: '2_HOURS', label: '2 Hours (After removed from cart)', minutes: 2 * 60 },
					{ value: '1_DAY', label: '1 Day (After removed from cart)', minutes: 24 * 60 },
					{ value: 'CUSTOM', label: 'Custom (After removed from cart)', minutes: null }
				];
			} else if (sequenceIndex === 1) {
				return defaultSecondThirdOptions;
			} else {
				return defaultThirdOptions;
			}

		case 'ABANDONED_CHECKOUT':
			if (sequenceIndex === 0) {
				return [
					{ value: '15_MINUTES', label: '15 Minutes (After abandoned checkout)', minutes: 15 },
					{ value: '1_HOUR', label: '1 Hour (After abandoned checkout)', minutes: 60 },
					{ value: 'CUSTOM', label: 'Custom (After abandoned checkout)', minutes: null }
				];
			} else if (sequenceIndex === 1) {
				return defaultSecondThirdOptions;
			} else {
				return defaultThirdOptions;
			}

		case 'INACTIVE_USER':
			if (sequenceIndex === 0) {
				return [
					{ value: '15_DAYS', label: '15 Days (After app launched)', minutes: 15 * 24 * 60 },
					{ value: '30_DAYS', label: '30 Days (After app launched)', minutes: 30 * 24 * 60 },
					{ value: 'CUSTOM', label: 'Custom (After app launched)', minutes: null }
				];
			} else if (sequenceIndex === 1) {
				return defaultSecondThirdOptions;
			} else {
				return defaultThirdOptions;
			}

		default:
			// Fallback to original logic
			if (sequenceIndex === 0) {
				return [
					{ value: '2_MINUTES', label: '2 Minutes (After app installed)', minutes: 2 },
					{ value: '15_MINUTES', label: '15 Minutes (After app installed)', minutes: 15 },
					{ value: 'CUSTOM', label: 'Custom (After app installed)', minutes: null }
				];
			} else if (sequenceIndex === 1) {
				return defaultSecondThirdOptions;
			} else {
				return defaultThirdOptions;
			}
	}
}; 